// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FreshLoop social-proof/customer-count section */
:root {
  --fl-forest: #164b37;
  --fl-green: #236a4d;
  --fl-ink: #153d30;
  --fl-muted: #61766a;
}
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  background: #f8f7f1;
  color: var(--fl-ink);
  font-family:
    Inter,
    system-ui,
    -apple-system,
    "Segoe UI",
    sans-serif;
}
.demo-page {
  width: min(100% - 32px, 1080px);
  margin: 48px auto;
}
.customer-proof {
  position: relative;
  isolation: isolate;
  display: grid;
  grid-template-columns: minmax(200px, 0.95fr) minmax(320px, 1.35fr) minmax(
      150px,
      0.7fr
    );
  align-items: center;
  width: 68%;
  margin: auto;
  gap: clamp(16px, 2.4vw, 32px);
  min-height: 154px;
  padding: 22px clamp(20px, 3vw, 38px);
  overflow: hidden;
  border: 1px solid #dce8d7;
  border-radius: 18px;
  background:
    radial-gradient(
      circle at 0% 0%,
      rgba(180, 211, 151, 0.28),
      transparent 28%
    ),
    radial-gradient(
      circle at 100% 100%,
      rgba(180, 211, 151, 0.22),
      transparent 24%
    ),
    linear-gradient(105deg, #f0f6e4, #fbfcf3 52%, #eef5e2);
  box-shadow: 0 10px 28px rgba(24, 63, 45, 0.06);
}
.proof-people {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  padding-left: 4px;
}
.avatar,
.avatar-more {
  display: grid;
  place-items: center;
  flex: 0 0 54px;
  width: 54px;
  height: 54px;
  margin-left: -12px;
  border: 3px solid #fffdf5;
  border-radius: 50%;
  color: white;
  font-size: 17px;
  font-weight: 800;
  box-shadow: 0 3px 8px rgba(20, 65, 45, 0.13);
}
.avatar:first-child {
  margin-left: 0;
}
.avatar--one {
  background: linear-gradient(140deg, #d49b71, #315c48);
}
.avatar--two {
  background: linear-gradient(140deg, #b7c9b0, #6a8872);
}
.avatar--three {
  background: linear-gradient(140deg, #e2b48e, #8b5442);
}
.avatar--four {
  background: linear-gradient(140deg, #d6c3a2, #4a6551);
}
.avatar--five {
  background: linear-gradient(140deg, #bd8c6b, #263e35);
}
.avatar-more {
  z-index: 2;
  flex-basis: 56px;
  width: 56px;
  height: 56px;
  margin-left: -10px;
  background: var(--fl-forest);
  font-size: 16px;
}
.proof-copy {
  min-width: 0;
}
.proof-eyebrow {
  margin: 0 0 2px;
  color: var(--fl-green);
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.16em;
}
.proof-copy h2 {
  margin: 0;
  color: #173d30;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(34px, 4.1vw, 56px);
  font-weight: 700;
  letter-spacing: -0.045em;
  line-height: 1.05;
  white-space: nowrap;
}
.customer-count {
  color: #2d6a4b;
}
.proof-subtitle {
  margin: 7px 0 0;
  color: var(--fl-muted);
  font-size: 13px;
  line-height: 1.45;
}
.proof-thanks {
  position: relative;
  justify-self: end;
  transform: rotate(-5deg);
  color: #315f43;
}
.proof-thanks p {
  margin: 0;
  font-family: Georgia, serif;
  font-size: 17px;
  font-style: italic;
  font-weight: 700;
  line-height: 1.25;
}
.thanks-spark {
  position: absolute;
  top: -14px;
  left: -18px;
  font-size: 31px;
  font-weight: 900;
  transform: rotate(-35deg);
}
.thanks-heart {
  display: block;
  margin-top: 3px;
  text-align: right;
  font-size: 32px;
  line-height: 1;
}
.proof-leaves {
  position: absolute;
  z-index: -1;
  color: #b7d5a3;
  opacity: 0.55;
  font-size: 78px;
  line-height: 1;
}
.proof-leaves--left {
  top: -22px;
  left: -12px;
  transform: rotate(-25deg);
}
.proof-leaves--right {
  right: -8px;
  bottom: -26px;
  transform: rotate(35deg);
}
@media (max-width: 760px) {
  .demo-page {
    width: min(100% - 24px, 560px);
    margin: 28px auto;
  }
  .customer-proof {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 13px;
    padding: 24px 18px 20px;
    width: 93%;
    text-align: center;
  }
  .proof-people {
    justify-content: center;
  }
  .avatar {
    flex-basis: 47px;
    width: 47px;
    height: 47px;
    font-size: 15px;
  }
  .avatar-more {
    flex-basis: 49px;
    width: 49px;
    height: 49px;
    font-size: 15px;
  }
  .proof-copy h2 {
    white-space: normal;
    font-size: clamp(34px, 9vw, 46px);
  }
  .proof-subtitle {
    max-width: 300px;
    margin-inline: auto;
  }
  .proof-thanks {
    display: none;
  }
}
@media (max-width: 360px) {
  .avatar {
    flex-basis: 40px;
    width: 40px;
    height: 40px;
    margin-left: -10px;
  }
  .avatar-more {
    flex-basis: 43px;
    width: 43px;
    height: 43px;
    margin-left: -8px;
  }
  .proof-copy h2 {
    font-size: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/CustomerCount.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB;;;;;cAKY;AACd;AACA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb;;;KAGG;EACH,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;;;;;;;;;;0DAWwD;EACxD,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,cAAc;AAChB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,cAAc;EACd,8CAA8C;EAC9C,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,SAAS;IACT,uBAAuB;IACvB,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,iCAAiC;EACnC;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* FreshLoop social-proof/customer-count section */\n:root {\n  --fl-forest: #164b37;\n  --fl-green: #236a4d;\n  --fl-ink: #153d30;\n  --fl-muted: #61766a;\n}\n* {\n  box-sizing: border-box;\n}\nbody {\n  margin: 0;\n  background: #f8f7f1;\n  color: var(--fl-ink);\n  font-family:\n    Inter,\n    system-ui,\n    -apple-system,\n    \"Segoe UI\",\n    sans-serif;\n}\n.demo-page {\n  width: min(100% - 32px, 1080px);\n  margin: 48px auto;\n}\n.customer-proof {\n  position: relative;\n  isolation: isolate;\n  display: grid;\n  grid-template-columns: minmax(200px, 0.95fr) minmax(320px, 1.35fr) minmax(\n      150px,\n      0.7fr\n    );\n  align-items: center;\n  width: 68%;\n  margin: auto;\n  gap: clamp(16px, 2.4vw, 32px);\n  min-height: 154px;\n  padding: 22px clamp(20px, 3vw, 38px);\n  overflow: hidden;\n  border: 1px solid #dce8d7;\n  border-radius: 18px;\n  background:\n    radial-gradient(\n      circle at 0% 0%,\n      rgba(180, 211, 151, 0.28),\n      transparent 28%\n    ),\n    radial-gradient(\n      circle at 100% 100%,\n      rgba(180, 211, 151, 0.22),\n      transparent 24%\n    ),\n    linear-gradient(105deg, #f0f6e4, #fbfcf3 52%, #eef5e2);\n  box-shadow: 0 10px 28px rgba(24, 63, 45, 0.06);\n}\n.proof-people {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  padding-left: 4px;\n}\n.avatar,\n.avatar-more {\n  display: grid;\n  place-items: center;\n  flex: 0 0 54px;\n  width: 54px;\n  height: 54px;\n  margin-left: -12px;\n  border: 3px solid #fffdf5;\n  border-radius: 50%;\n  color: white;\n  font-size: 17px;\n  font-weight: 800;\n  box-shadow: 0 3px 8px rgba(20, 65, 45, 0.13);\n}\n.avatar:first-child {\n  margin-left: 0;\n}\n.avatar--one {\n  background: linear-gradient(140deg, #d49b71, #315c48);\n}\n.avatar--two {\n  background: linear-gradient(140deg, #b7c9b0, #6a8872);\n}\n.avatar--three {\n  background: linear-gradient(140deg, #e2b48e, #8b5442);\n}\n.avatar--four {\n  background: linear-gradient(140deg, #d6c3a2, #4a6551);\n}\n.avatar--five {\n  background: linear-gradient(140deg, #bd8c6b, #263e35);\n}\n.avatar-more {\n  z-index: 2;\n  flex-basis: 56px;\n  width: 56px;\n  height: 56px;\n  margin-left: -10px;\n  background: var(--fl-forest);\n  font-size: 16px;\n}\n.proof-copy {\n  min-width: 0;\n}\n.proof-eyebrow {\n  margin: 0 0 2px;\n  color: var(--fl-green);\n  font-size: 11px;\n  font-weight: 850;\n  letter-spacing: 0.16em;\n}\n.proof-copy h2 {\n  margin: 0;\n  color: #173d30;\n  font-family: Georgia, \"Times New Roman\", serif;\n  font-size: clamp(34px, 4.1vw, 56px);\n  font-weight: 700;\n  letter-spacing: -0.045em;\n  line-height: 1.05;\n  white-space: nowrap;\n}\n.customer-count {\n  color: #2d6a4b;\n}\n.proof-subtitle {\n  margin: 7px 0 0;\n  color: var(--fl-muted);\n  font-size: 13px;\n  line-height: 1.45;\n}\n.proof-thanks {\n  position: relative;\n  justify-self: end;\n  transform: rotate(-5deg);\n  color: #315f43;\n}\n.proof-thanks p {\n  margin: 0;\n  font-family: Georgia, serif;\n  font-size: 17px;\n  font-style: italic;\n  font-weight: 700;\n  line-height: 1.25;\n}\n.thanks-spark {\n  position: absolute;\n  top: -14px;\n  left: -18px;\n  font-size: 31px;\n  font-weight: 900;\n  transform: rotate(-35deg);\n}\n.thanks-heart {\n  display: block;\n  margin-top: 3px;\n  text-align: right;\n  font-size: 32px;\n  line-height: 1;\n}\n.proof-leaves {\n  position: absolute;\n  z-index: -1;\n  color: #b7d5a3;\n  opacity: 0.55;\n  font-size: 78px;\n  line-height: 1;\n}\n.proof-leaves--left {\n  top: -22px;\n  left: -12px;\n  transform: rotate(-25deg);\n}\n.proof-leaves--right {\n  right: -8px;\n  bottom: -26px;\n  transform: rotate(35deg);\n}\n@media (max-width: 760px) {\n  .demo-page {\n    width: min(100% - 24px, 560px);\n    margin: 28px auto;\n  }\n  .customer-proof {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    gap: 13px;\n    padding: 24px 18px 20px;\n    width: 93%;\n    text-align: center;\n  }\n  .proof-people {\n    justify-content: center;\n  }\n  .avatar {\n    flex-basis: 47px;\n    width: 47px;\n    height: 47px;\n    font-size: 15px;\n  }\n  .avatar-more {\n    flex-basis: 49px;\n    width: 49px;\n    height: 49px;\n    font-size: 15px;\n  }\n  .proof-copy h2 {\n    white-space: normal;\n    font-size: clamp(34px, 9vw, 46px);\n  }\n  .proof-subtitle {\n    max-width: 300px;\n    margin-inline: auto;\n  }\n  .proof-thanks {\n    display: none;\n  }\n}\n@media (max-width: 360px) {\n  .avatar {\n    flex-basis: 40px;\n    width: 40px;\n    height: 40px;\n    margin-left: -10px;\n  }\n  .avatar-more {\n    flex-basis: 43px;\n    width: 43px;\n    height: 43px;\n    margin-left: -8px;\n  }\n  .proof-copy h2 {\n    font-size: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
